import actionCreatorFactory from 'typescript-fsa';
import * as type from '../types/discount_pack';
var actionCreator = actionCreatorFactory();
export var requestDiscountPacks = actionCreator(type.REQUEST_DISCOUNT_PACK);
export var successDiscountPacks = actionCreator(type.SUCCESS_DISCOUNT_PACK);
export var failureDiscountPacks = actionCreator(type.FAILURE_DISCOUNT_PACK);
export var requestDiscountPackDetail = actionCreator(type.REQUEST_DETAIL_DISCOUNT_PACK);
export var successDiscountPackDetail = actionCreator(type.SUCCESS_DETAIL_DISCOUNT_PACK);
export var failureDiscountPackDetail = actionCreator(type.FAILURE_DETAIL_DISCOUNT_PACK);